import { motion } from "framer-motion";

const StatCard = ({
  title,
  subtitle,
  count,
  change,
  trend,
  color,
  icon,
  itemVariants,
}) => {
  return (
    <motion.div
      variants={itemVariants}
      className="relative bg-white rounded-xl shadow-sm overflow-hidden"
    >
      <div className={`absolute top-0 left-0 w-1 h-full bg-${color}`} />
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div className="space-y-1">
            <p className="text-sm text-gray-500">{subtitle}</p>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
          <div
            className={`p-2 rounded-lg bg-${color}-50 text-${color}`}
          >
            {icon}
          </div>
        </div>
        <div className="flex items-baseline gap-3">
          <span className="text-3xl font-bold text-gray-900">{count}</span>
          <span
            className={`flex items-center text-sm ${
              trend === "up" ? "text-green-600" : "text-red-600"
            }`}
          >
            {trend === "up" ? "↑" : "↓"} {Math.abs(change)}%
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
